import { pathToAction } from 'redux-first-router';
import routesGenerator from '@/router/routesGenerator';
import { ROUTE_COMPANY } from '@/constants/routes';
import { isValidSection } from '@/pages/CompanyReport/useSection';

export function getCurrentRoute() {
  try {
    const action = pathToAction(window.location.pathname, routesGenerator());
    if (action.type === ROUTE_COMPANY) {
      const { payload } = action;
      const { section } = payload;
      //For company split routes
      //TODO: @victorc merge names back to @COMPANY for sentry later
      if (typeof section === 'string' && isValidSection(section)) {
        return `${action.type}/SPLIT/${section.toUpperCase()}`;
      }
      return `${action.type}/SPLIT`;
    }
    return action.type;
  } catch {
    return 'unmapped';
  }
}
